module.exports = require("eslint-scope");